export const AUTH_TOKEN = "qwertyuiopsdfghjjgfdsdertyuioi";
